module.exports = __webpack_public_path__ + "static/media/ser_war_sig.034f618d.png";